import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import Inquiry from "./sections/Inquiry";
import Presence from "./sections/Presence";
import Direct from "./sections/Direct";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <Inquiry />
      <Presence />
      <Direct />
      <Footer />
    </div>;
}